export default function TextField(theme) {

  return {
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiInputLabel-root': {
            color: 'grey', // Cor do rótulo padrão
          },
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: theme.palette.grey[500], // Cor da borda padrão
              borderWidth: 1
            },
            '&:hover fieldset': {
              borderColor: theme.palette.primary.main, // Cor da borda ao passar o mouse
              borderWidth: 1
            },
            '&.Mui-focused fieldset': {
              borderColor: theme.palette.primary.main, // Cor da borda quando focado
              borderWidth: 1
            },
            '&.Mui-disabled': {
              '& fieldset': {
                borderColor: theme.palette.grey[300], // Cor da borda quando desativado
                borderWidth: 1
              },
              '& .MuiInputLabel-root': {
                color: theme.palette.grey[300], // Cor do rótulo quando desativado
              },
            },
          },
        },
      },
    },
  };
}
